import React from 'react';

import styled from 'styled-components';

import IconHeart from 'components/icons/heart';
import { filterProps } from 'utils/filter-props';

import { IFavoriteIcon } from './types';

const FavIconHeart = styled(filterProps(IconHeart, 'isFavorite'))<{ isFavorite: boolean }>`
  fill: ${p => (p.isFavorite ? Styles.color.primary : Styles.color.grey.four)};
  height: 20px;
  width: 20px;
`;

export const FavoriteIcon: React.FC<IFavoriteIcon> = ({ isFavorite }) => (
  <FavIconHeart isFavorite={isFavorite} />
);
